'use client';

import { use, lazy } from 'react';
import { TermsAndConditionsViewQuery } from '@bts-web/data-layer/server';

const TermsAndConditionsModal = lazy(() =>
  import('../../terms-and-conditions/TermsAndConditionsModal').then((mod) => ({
    default: mod.TermsAndConditionsModal,
  })),
);

export const NewTermsAndConditionsObserver = ({
  termsPromise,
}: {
  termsPromise: Promise<{
    data: TermsAndConditionsViewQuery['response'];
    errors?: string[];
  } | null>;
}) => {
  const response = use(termsPromise);

  const termsData = response?.data?.termsAndConditions;

  if (!termsData) return null;

  return <TermsAndConditionsModal termsAndConditions={termsData} />;
};
